import { createListenerMiddleware } from '@reduxjs/toolkit';
import { addError } from './errors';

export const errorListener = createListenerMiddleware();

errorListener.startListening({
  predicate: action => {
    return !!(action.error && action.error.message.startsWith('RequestError'));
  },
  effect: (action, listenerApi) => {
    listenerApi.dispatch(addError(action.error));
  },
});

export default errorListener.middleware;
